import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AlertTriangle, Package } from "lucide-react";
import { StockDualValue } from "@/components/Stock/StockDualValue";

export function ExpiringProductsModal({ open, onOpenChange, expiringProducts = [] }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto" data-testid="expiring-products-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <AlertTriangle className="w-5 h-5" />
            Produtos com Vencimento Próximo
          </DialogTitle>
          <DialogDescription>
            {expiringProducts.length} produtos vencem nos próximos 7 dias
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <div className="grid gap-3">
            {expiringProducts.map((product, idx) => (
              <div
                key={idx}
                className={`flex items-center justify-between p-3 rounded-lg border ${
                  product.days_until_expiry <= 0
                    ? 'bg-red-50 border-red-200'
                    : product.days_until_expiry <= 3
                      ? 'bg-amber-50 border-amber-200'
                      : 'bg-slate-50 border-slate-200'
                }`}
              >
                <div className="flex items-center gap-3">
                  {product.image_url ? (
                    <img
                      src={product.image_url}
                      alt={product.name}
                      className="w-12 h-12 object-cover rounded-lg"
                    />
                  ) : (
                    <div className="w-12 h-12 bg-slate-200 rounded-lg flex items-center justify-center">
                      <Package className="w-6 h-6 text-slate-400" />
                    </div>
                  )}
                  <div>
                    <h4 className="font-medium text-slate-800">{product.name}</h4>
                    <div className="flex items-center gap-2 text-sm text-slate-500">
                      <span>EAN: {product.ean}</span>
                      <span>•</span>
                      <span>Lote: {product.batch_number || 'N/A'}</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className={`text-lg font-bold ${
                    product.days_until_expiry <= 0
                      ? 'text-red-600'
                      : product.days_until_expiry <= 3
                        ? 'text-amber-600'
                        : 'text-slate-700'
                  }`}>
                    {product.days_until_expiry <= 0
                      ? 'VENCIDO'
                      : product.days_until_expiry === 0
                        ? 'Vence HOJE'
                        : `${product.days_until_expiry} dia${product.days_until_expiry > 1 ? 's' : ''}`}
                  </div>
                  <div className="text-sm text-slate-500 flex items-center gap-2 flex-wrap">
                    <span>{product.expiry_date}</span>
                    <span>•</span>
                    <span>Estoque:</span>
                    <StockDualValue
                      product={{ ...product, current_stock: product.remaining_qty ?? product.total_stock }}
                      inline
                      size="sm"
                    />
                  </div>
                  {product.daily_avg_sales > 0 && (
                    <div className="text-xs text-slate-400">
                      Vende ~{product.daily_avg_sales}/dia • Dura ~{product.days_of_stock} dias
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
